import { Component, type ErrorInfo, type ReactNode } from "react";
import { Sentry } from "../lib/sentry";

interface Props { children: ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[ErrorBoundary]", error, info.componentStack);
    // Report to Sentry (noop wenn kein DSN konfiguriert)
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info.componentStack || "" } },
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0f172a",
        color: "#e2e8f0",
        fontFamily: "Inter, system-ui, sans-serif",
        padding: 24,
      }}>
        <div style={{ maxWidth: 480, textAlign: "center" }}>
          <h1 style={{ fontSize: 20, marginBottom: 12 }}>Es ist ein Fehler aufgetreten</h1>
          <p style={{ fontSize: 14, color: "#94a3b8", marginBottom: 20 }}>
            Die Seite konnte nicht angezeigt werden. Bitte neu laden.
          </p>
          <pre style={{
            fontSize: 12,
            color: "#f87171",
            background: "#1e293b",
            padding: 12,
            borderRadius: 8,
            textAlign: "left",
            overflow: "auto",
            marginBottom: 20,
          }}>{this.state.error.message}</pre>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 24px",
              background: "#00A3E0",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >Neu laden</button>
        </div>
      </div>
    );
  }
}
